export type ReferralStatus = "active" | "inactive";

export type ReferralStatusFilter = "all" | ReferralStatus;

export type ReferralListItem = {
  id: string;
  name: string;
  email: string;
  initials: string;
  registeredAt: string;
  offerName: string | null;
  status: ReferralStatus;
};

export type ReferralDashboardData = {
  isEligible: boolean;
  referralLink: string | null;
  referrals: ReferralListItem[];
  totalReferrals: number;
  activeReferrals: number;
  inactiveReferrals: number;
  rewardAmount: number;
  policy: {
    unpaidThreshold: number;
    rewardPerActiveReferralFcfa: number;
    smartProMilestone: number;
  };
};

export const REFERRAL_PAGE_SIZE = 8;
